/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Price_TitleInputs */

const en_cp_price_title = /** @type {(inputs: Cp_Price_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per team, per semester — not per student`)
};

const id_cp_price_title = /** @type {(inputs: Cp_Price_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per tim, per semester — bukan per mahasiswa`)
};

/**
* | output |
* | --- |
* | "Per team, per semester — not per student" |
*
* @param {Cp_Price_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_price_title = /** @type {((inputs?: Cp_Price_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Price_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_price_title(inputs)
	return en_cp_price_title(inputs)
});